import { observable, runInAction, action } from "mobx";
import { ApiResult, FieldType, ViewModelBase } from "@shoothill/core";
import { InductionAdminNearMissAndRelatedResponseDTO, InductionAdminNearMissItemDTO, InductionAdminNearMissModel } from "./InductionAdminNearMissModel";
import { ServerViewModel } from "Globals/ViewModels/ServerViewModel";
import { AppUrls } from "AppUrls";

export class InductionAdminNearMissViewModel extends ViewModelBase<InductionAdminNearMissModel> {
    public server: ServerViewModel = new ServerViewModel();

    @observable public incidentItemList: InductionAdminNearMissItemDTO[] = [];

    constructor(incidentUserId: string) {
        super(new InductionAdminNearMissModel());
        this.setDecorators(InductionAdminNearMissViewModel);

        this.loadNearMissesAndRelated(incidentUserId);
    }

    public loadNearMissesAndRelated = async (id: string): Promise<ApiResult<InductionAdminNearMissAndRelatedResponseDTO>> => {
        this.setIsLoading(true);
        let params = { id: id };

        const apiResult = await this.Post<InductionAdminNearMissAndRelatedResponseDTO>(AppUrls.Server.Induction.GetInductionIncidentFormNearMissByInductionUserId, params);
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    this.incidentItemList = apiResult.payload.incidentFormListItems;
                });
            } else {
                console.log(apiResult.errors);
            }
        }
        this.setIsLoading(false);
        return apiResult;
    };

    @action
    public handleRowClick = (e: any, rowData: InductionAdminNearMissItemDTO) => {
        if (rowData) {
            this.history.push(
                AppUrls.Client.Project.Incident.NearMiss.View.replace(":projectid", rowData.projectId)
                    .replace(":incidentid", rowData.incidentId)
                    .replace(":incidentnearmissid", rowData.id),
            );
        }
    };

    public async isFieldValid(fieldName: keyof FieldType<InductionAdminNearMissModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
